import { useState } from "react";
import BaseCard from "../../../../../components/ui/BaseCard";
import AddEquipmentModal from "../../../components/AddEquipmentModal";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteUserQualification,
  fetchUserQualificationsByType,
} from "../../../../../services/api/user";
import { useDispatch } from "react-redux";
import { showToast } from "../../../../../store/toast/toastSlice";

import BaseTooltip from "../../../../../components/ui/BaseTooltip";

const AddEquipments = ({ userId, equipmentId }) => {
  const dispatch = useDispatch();

  const [isAddEquipmentModalOpen, setIsAddEquipmentModalOpen] = useState(false);

  const {
    isPending: isDeletedQualificationApiLoading,
    error: isDeletedQualificationApiError,
    data: deletedQualificationsData,
    mutateAsync: deleteUserQualificationMutation,
  } = useMutation({
    mutationFn: deleteUserQualification,
    enabled: false,
  });

  const {
    data: userQualificationsData,
    isPending: isUserQualificationsApiLoading,
    error: isUserQualificationsApiError,
    refetch: refetchUserQualificationsByType,
  } = useQuery({
    queryKey: ["equipment"],
    queryFn: () => fetchUserQualificationsByType(userId, equipmentId),
    enabled: !!equipmentId && !!userId,
  });

  const handleDeleteUserQualification = async (id) => {
    try {
      const userDeletedQualificationsResponse =
        await deleteUserQualificationMutation(id);
      dispatch(
        showToast({
          message: "Equipment deleted successfully",
          type: "success",
        })
      );
      refetchUserQualificationsByType();
      setIsAddEquipmentModalOpen(false);
    } catch (error) {}
  };

  return (
    <form>
      <BaseCard
        className="py-3 px-4 mt-3 border rounded-lg shadow-sm"
        elevation={0}
      >
        <div className="bg-light rounded-sm py-2 px-4 mb-4 flex items-center justify-between">
          <p className="text-base font-normal">Add Equipments</p>
          <i
            className="fa-solid fa-circle-plus cursor-pointer text-secondary text-xl"
            onClick={() => setIsAddEquipmentModalOpen(true)}
          ></i>
        </div>

        <div className="flex flex-wrap gap-4">
          {userQualificationsData?.data?.map((equipment) => (
            <BaseTooltip
              key={equipment?.id}
              placement="top"
              interactive={true}
              content={
                equipment?.url ? (
                  <img
                    src={equipment.url}
                    alt="Qualification"
                    className="w-64 max-w-xs h-auto rounded shadow-lg border border-gray-300"
                  />
                ) : (
                  "No preview available"
                )
              }
            >
              <div className="flex items-center px-4 py-1 bg-light rounded-sm cursor-default">
                <p key={equipment?.id}>{equipment?.qualificationSubType}</p>
                {/*   <i
                className="fa-solid fa-xmark ml-2 cursor-pointer hover:text-blue-500"
                onClick={() => handleDeleteUserQualification(qualification.id)}
              ></i> */}
              </div>
            </BaseTooltip>
          ))}
        </div>
      </BaseCard>

      {isAddEquipmentModalOpen && (
        <AddEquipmentModal
          open={isAddEquipmentModalOpen}
          close={setIsAddEquipmentModalOpen}
          equipmentId={equipmentId}
          refetchUserQualificationsByType={refetchUserQualificationsByType}
          equipments={userQualificationsData?.data}
        />
      )}
    </form>
  );
};

export default AddEquipments;
